import React from 'react'
import Typography from '@mui/material/Typography'
import { v4 as uuidv4 } from 'uuid'
import { useFormContext } from 'react-hook-form'
import { WarrantEntity, WarrantSubscriptionPeriod } from 'types/WarrantEntity'
import WarrantSubPeriod from './AdminWarrantSubPeriod'
import Button from '@mui/material/Button'

type WarrantSubPeriodsProps = {
    setIsCustomFormDirty: (val: boolean) => void
    warrant: WarrantEntity
}

export function WarrantSubPeriods({ warrant, setIsCustomFormDirty }: WarrantSubPeriodsProps) {
    const formMethods = useFormContext()

    const warrantSubPeriods = formMethods.watch('subscriptionPeriods') as Array<
        WarrantSubscriptionPeriod & { tempId: string }
    >

    const handleRemoveSubPeriod = (subPeriod: WarrantSubscriptionPeriod & { tempId: string }) => {
        if (warrantSubPeriods.length > 0) {
            const newSubPeriods = warrantSubPeriods.filter((sp) =>
                subPeriod.id ? sp.id !== subPeriod.id : sp.tempId !== subPeriod.tempId,
            )
            setIsCustomFormDirty(true)
            formMethods.setValue('subscriptionPeriods', newSubPeriods)
        }
    }
    const emptySubPeriod = (tempId: string, warrantId: string) => ({
        tempId,
        warrantId,
        subStartDate: null,
        subEndDate: null,
        warrantsRequired: null,
        commitments: null,
        guarantors: null,
        sharesSubscribed: null,
        sharesReceived: null,
        warrantSubPrice: null,
        vwapDiscount: null,
        vwapDays: null,
        vwapPeriodEnd: null,
        priceMinQuota: null,
        priceMin: null,
        noPriceMax: null,
        priceMax: null,
        isVwap: false,
    })
    const handleShowNewPeriodForm = () => {
        // setShowNewPeriodButton(!showNewPeriodButton)
        const newSubPeriods = [...warrantSubPeriods, emptySubPeriod(uuidv4(), warrant.id)]
        setIsCustomFormDirty(true)
        formMethods.setValue('subscriptionPeriods', newSubPeriods)
    }

    return (
        <>
            <Typography variant='h5' gutterBottom display='block'>
                Teckningsperioder
            </Typography>
            {warrantSubPeriods.length === 0 && (
                <Typography variant='body1'>Inga befintliga teckningsperioder hittades</Typography>
            )}
            {warrantSubPeriods.length > 0 &&
                warrantSubPeriods.map((subPeriod, index) => (
                    <WarrantSubPeriod
                        subPeriod={subPeriod}
                        subPeriodIndex={index}
                        key={subPeriod.id || subPeriod.tempId}
                        handleRemoveSubPeriod={handleRemoveSubPeriod}
                    />
                ))}
            <Button variant='outlined' sx={{ my: 2 }} onClick={handleShowNewPeriodForm}>
                Ny teckningsperiod
            </Button>
        </>
    )
}
